import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const Value = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`suspiciousActivityInfo.marketsTraded.${index as 0}.value`}
      control={control}
      render={({ field }) => <FF2 label="Value" field={field} input={(props) => <TextInput {...props} />} />}
    />
  )
}
